import * as React from "react";

import "./streets-section.scss";

import {isApiFalse}     from "@Common/logic/is-api-false";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {snv}            from "@Common/utils/arr-path";
import {unique}         from "@Common/utils/collections";
import {chain}          from "@Common/utils/fs";

import {AddressBox} from "./address-box/address-box";
import {StreetsBox} from "./streets-box/streets-box";

/**
 * Handles streets and individual addresses
 */
export const StreetsSection = ({searchedForm, next}) => cs(
    consumeContext("apis"),


    ["streetsBox", ({}, next) => StreetsBox({next})],
    ["addressBox", ({}, next) => AddressBox({
        searchedForm,
        next,
    })],

    ({addressBox, streetsBox}) => next({
        hasData: streetsBox.hasData,

        setSearchResult: (result) => {
            addressBox.clear();
            streetsBox.setStreets(result);
        },
        getNextAction: ({onNext}) => !streetsBox.hasData ? null : (() => {
            const valid = streetsBox.containsAddresses({
                getExcludedAddrCounts: addressBox.getExcludedAddrCounts,
            });
            return {
                disabled: !valid,
                action: () => {
                    if(!valid) {
                        streetsBox.highlightErrors();
                    } else {
                        onNext();
                    }
                },
            };
        })(),
        createRequestData: async () => ({
            ...streetsBox.data,

            streets: await (async () => {
                let streets = streetsBox.data.streets;

                const excludedStreets = streetsBox.getExcludedStreets();
                const involvedStreets = addressBox.getInvolvedStreets(Object.entries(streets));
                const searchStreets = [...new Set([...involvedStreets, ...excludedStreets])];
                const radiusAddresses = await addressBox.loadAddresses(searchStreets ?? [], {getStreetRecord: streetsBox.getStreetRecord});
                if (radiusAddresses?.result === "failed") {
                    return radiusAddresses;
                }

                for (const streetName of searchStreets) {
                    streets = snv(
                        streets, [streetName, "IndividualAddresses"],
                        radiusAddresses[streetName].map((addr) => ({
                            ...addr,
                            display_address: (
                                excludedStreets.includes(streetName) ||
                                addressBox.isAddressExcluded(streetName, addr.address) ||
                                isApiFalse(addr.display_address)
                            ) ? (
                                "0"
                            ) : (
                                "1"
                            ),
                        }))
                    );

                    if (excludedStreets.includes(streetName)) {
                        streets = snv(
                            streets, [streetName, "addresses", streetName, "display_address"],
                            "1" // TODO this is freaky, why display is "1" when it's excluded? Weird API
                        );
                    }
                }

                return streets;
            })(),
        }),
        loadAddresses: addressBox.loadAddresses,

        render: ({searchedAddress}) => cs(
            () => streetsBox.hasData && (
                <div className="streets-section-9dk">
                    <div className="header">
                        <div className="line1">
                            {streetsBox.data.warningMessage && <div className="warning">{streetsBox.data.warningMessage}</div>}
                            <div className="title" xd-qa-type="label" xd-qa-name="Build Radius List Searching On">
                                Searching on…
                            </div>
                            <div className="address" xd-qa-type="label" xd-qa-name="Build Radius List Search Address">
                                {searchedAddress}
                            </div>
                            {/*<div className="count">*/}
                            {/*    (55 Addresses)*/}
                            {/*</div>*/}
                        </div>
                        <div className="sub-title" xd-qa-type="label" xd-qa-name="Build Radius List Searching On Description">
                            Choose which streets you want to include in your list.
                        </div>
                    </div>


                    {streetsBox.render({
                        searchState: addressBox.searchState,
                        getExcludedCounts: addressBox.getExcludedAddrCounts,
                    })}

                    {addressBox.render({
                        getStreetRecords: streetsBox.getStreetRecords
                    })}
                </div>
            ),
        ),
    }),
);

